import React from "react";
import { useTranslation } from "react-i18next";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";

export type FeedbackSettingsTab = "reservations" | "requests" | "communication";

interface FeedbackSettingsTabsProps {
  activeTab: FeedbackSettingsTab;
  onTabChange: (tab: FeedbackSettingsTab) => void;
}

const tabs: FeedbackSettingsTab[] = [
  "reservations",
  "requests",
  "communication",
];

export const FeedbackSettingsTabs = ({
  activeTab,
  onTabChange,
}: FeedbackSettingsTabsProps): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <Tabs
      value={activeTab}
      onValueChange={(value) => onTabChange(value as FeedbackSettingsTab)}
      className="mx-auto w-full max-w-3xl"
    >
      <TabsList className="grid h-auto w-full grid-cols-3 rounded-lg bg-muted p-1">
        {tabs.map((tab) => (
          <TabsTrigger
            key={tab}
            value={tab}
            className={cn(
              "h-8 rounded-md border border-transparent text-sm font-medium shadow-none transition-colors disabled:cursor-not-allowed disabled:opacity-60",
              "data-[state=active]:border-custom-outline data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-none",
            )}
          >
            {t(`feedbacks.settings.tabs.${tab}`)}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};
